import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavComponent } from './side-nav/side-nav.component';
import { RouterModule } from '@angular/router';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { ModalModule } from 'ngx-bootstrap/modal';
import { UpdateToServerModalComponent } from './update-to-server-modal/update-to-server-modal.component';
import { CheckingOutModalComponent } from './checking-out-modal/checking-out-modal.component';
import { AlertModule } from 'ngx-bootstrap/alert';
import { LogoutModalComponent } from './logout-modal/logout-modal.component';
import { UserIdleModalComponent } from './user-idle-modal/user-idle-modal.component';
import { FormsModule } from '@angular/forms';
import { DataExpiryModalComponent } from './data-expiry-modal/data-expiry-modal.component';
import { PleaseWaitModalComponent } from './please-wait-modal/please-wait-modal.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { SessionExpiredModalComponent } from './session-expired-modal/session-expired-modal.component';
import { AddNewAssessmentModalComponent } from './add-new-assessment-modal/add-new-assessment-modal.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    AccordionModule.forRoot(),
    ProgressbarModule.forRoot(),
    ModalModule.forRoot(),
    AlertModule.forRoot()
  ],
  exports: [SideNavComponent],
  declarations: [
    SideNavComponent,
    UpdateToServerModalComponent,
    CheckingOutModalComponent,
    LogoutModalComponent,
    UserIdleModalComponent,
    DataExpiryModalComponent,
    PleaseWaitModalComponent,
    ErrorModalComponent,
    SessionExpiredModalComponent,
    AddNewAssessmentModalComponent
  ],
  entryComponents: [
    UpdateToServerModalComponent,
    CheckingOutModalComponent,
    LogoutModalComponent,
    UserIdleModalComponent,
    DataExpiryModalComponent,
    PleaseWaitModalComponent,
    ErrorModalComponent,
    SessionExpiredModalComponent,
    AddNewAssessmentModalComponent
  ]
})
export class SharedModule {}
